import { motion } from "framer-motion";
import { Mic } from "lucide-react";

export default function Nav() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 pointer-events-none"
      data-testid="chalann-nav"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between pointer-events-auto">
        <a href="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="w-2 h-2 rounded-full bg-[#ff5a00] group-hover:bg-[#ccff00] transition-colors duration-300" />
          <span className="font-display text-xl tracking-tighter">CHALANN</span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm text-white/60">
          <a href="#manifiesto" className="hover:text-white transition-colors duration-300" data-testid="nav-manifiesto">Manifiesto</a>
          <a href="#producto" className="hover:text-white transition-colors duration-300" data-testid="nav-producto">Producto</a>
          <a href="#giros" className="hover:text-white transition-colors duration-300" data-testid="nav-giros">Para quién</a>
          <a href="#precio" className="hover:text-white transition-colors duration-300" data-testid="nav-precio">Ahorro</a>
          <a href="#precios" className="hover:text-white transition-colors duration-300" data-testid="nav-precios">Precios</a>
          <a href="/dashboard" className="hover:text-white transition-colors duration-300" data-testid="nav-panel">Panel</a>
        </nav>

        <a
          href="/setup"
          className="btn-primary text-sm"
          data-testid="nav-cta"
        >
          <Mic size={16} strokeWidth={2.5} />
          Registrar tu negocio
        </a>
      </div>
    </motion.header>
  );
}
